// extracted by mini-css-extract-plugin
export default {"wrapper":"Success_wrapper__hMH0a","header":"Success_header__uVPcy","title":"Success_title__7+13R","buttonContinue":"Success_buttonContinue__s0MQX"};